import { ChatAssistant } from '../../types'
import { SupportChatAssistant } from './types'

import styles from './SupportOfflineGreetingCard.module.scss'

export type SupportOfflineGreetingCardProps = {
  assistant: ChatAssistant
}

export default function SupportOfflineGreetingCard({ assistant }: SupportOfflineGreetingCardProps) {
  const supportAssistant = assistant as SupportChatAssistant
  const offlineMessageSent = supportAssistant.offlineMessageSent

  if (offlineMessageSent) {
    return (
      <div className={styles.SupportOfflineGreetingCard}>
        <div className={styles.SupportOfflineGreetingCard__plaque}>
          <div className={styles.SupportOfflineGreetingCard__icon}>📫</div>
          <div className={styles.SupportOfflineGreetingCard__content}>
            <div className={styles.SupportOfflineGreetingCard__title}>Message received</div>
            <div className={styles.SupportOfflineGreetingCard__text}>
              Thanks for reaching out!
              <br />
              We&apos;ve received your message and will get back to you within 24 hours.
            </div>
            <div className={styles.SupportOfflineGreetingCard__actions}>
              <a
                href="https://helpcenter.aytm.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.SupportOfflineGreetingCard__linkPrimary}
              >
                Explore Help Center
              </a>
              <button
                type="button"
                className={styles.SupportOfflineGreetingCard__linkSecondary}
                onClick={() => supportAssistant.setOfflineMessageSent(false)}
              >
                Create another ticket
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.SupportOfflineGreetingCard}>
      <div className={styles.SupportOfflineGreetingCard__plaque}>
        <div className={styles.SupportOfflineGreetingCard__icon}>🌙</div>
        <div className={styles.SupportOfflineGreetingCard__content}>
          <div className={styles.SupportOfflineGreetingCard__title}>You&apos;ve reached us afterhours</div>
          <div className={styles.SupportOfflineGreetingCard__text}>
            Our Support team is available live <strong>Monday–Friday 9am–9pm EST</strong> (UTC-05:00) you can also email
            us at{' '}
            <a href="mailto:support@aytm.com" className={styles.SupportOfflineGreetingCard__emailLink}>
              support@aytm.com
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
